var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDrawerPayable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.714 6C10.32 6 10 5.619 10 5.15V1.978L13.742 6H10.714ZM11 16H5C4.448 16 4 15.552 4 15C4 14.448 4.448 14 5 14H11C11.553 14 12 14.448 12 15C12 15.552 11.553 16 11 16ZM5 10H8C8.552 10 9 10.448 9 11C9 11.552 8.552 12 8 12H5C4.448 12 4 11.552 4 11C4 10.448 4.448 10 5 10ZM15.74 5.328L11.296 0.328C11.107 0.119 10.838 0 10.556 0H2.556C1.147 0 0 1.122 0 2.5V17.5C0 18.878 1.147 20 2.556 20H13.444C14.854 20 16 18.878 16 17.5V6C16 5.751 15.907 5.512 15.74 5.328Z",
    fill: "#335C75"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerPayable);
export default __webpack_public_path__ + "static/media/DrawerPayable.f361d329.svg";
export { ForwardRef as ReactComponent };